const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/drivers/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { DRIVER_SORT_KEYS } from '@/features/fleet-management/driver/model/driver-columns';
import { createSearchValidator } from '@/lib/search-validators';
type DriverFilters = {
  status?: string;
  locationIds?: string;
  plates?: string;
};
const FILTER_KEYS: (keyof DriverFilters)[] = ['status', 'locationIds', 'plates'];
export const Route = createFileRoute('/_app/fleet-management/drivers/')({
  validateSearch: createSearchValidator<DriverFilters, string>({
    tabs: [],
    filterKeys: FILTER_KEYS,
    sortKeys: DRIVER_SORT_KEYS
  }),
  staticData: {
    breadCrumb: 'Drivers'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Mirrors vehicles' own `splitFilter` — the URL keeps a multiselect comma-joined. */